import router from './index'
import { globalObj, login } from '@/utils'
import appSDK from '@/utils/appSDK';
import { Dialog } from 'vant';

// 在免登录白名单，直接进入
let whiteList = [
    '/login',
    '/userProtocol',
    '/privacyProtocol',
    '/collegeDetail',
    '/quickEnter',
    '/invite',
    '/mentor',
    '/interest',
    '/collegeDetail',
    '/activityZgx',
    '/newMentorBinding',
    '/largeScreen',
    '/yearEnd',
    '/subPerformance'
]

// 路由校验
router.beforeEach((to, from, next) => {
    judgeEnvType(to)

    // 没有token直接到登录页
    if (!globalObj.getToken()) {
        // 没有token
        if (whiteList.indexOf(to.path) !== -1 || to.path.indexOf('Protocol') !== -1 || to.path.indexOf('invite') !== -1) {
            next() // 在免登录白名单，直接进入
        } else {
            login() // 否则全部重定向到登录页
            return
        }
    }
    next()
})

/**
 * Loading chunk 16 failed.
(missing:
https://banbeitest.banbeiyoutui.com:8558/js/16.24
09c34c.js)
 */
// 埋点，路由报错
router.onError(error => {
    console.log('路由报错', error.message);
    // 检查是否是加载 chunk 失败的报错（兼容 CSS chunk 加载失败），如果是则执行清空缓存
    if ((error.message.includes('Loading chunk') || error.message.includes('Loading CSS chunk')) && error.message.includes('failed')) {
        Dialog.confirm({
            title: '提示',
            message: '页面加载失败，请刷新重试',
            showCancelButton: true,
            confirmButtonText: '刷新',
        }).then(() => {
            appSDK.cleanCache();
        })
    }
})

// app传参处理
const judgeEnvType = (to) => {
    document.title = to?.meta?.title || '竹笋电商'
    if (to.query.token) {
        globalObj.setToken(to.query.token)
    }
    if (to.query.envType) {
        globalObj.setEnvType(to.query.envType)
    }
    if (to.query.appVersion) {
        globalObj.setAppVersion(to.query.appVersion)
    }
}

